import { useContext } from 'react';
import type * as React from 'react';
import { CardContext } from '../../utils/cardContext';
import { Builder as BuilderComponent } from '../../components/Builder';

export const Builder = (): React.JSX.Element => {
  const layout = useContext(CardContext);

  return <BuilderComponent builders={layout.builders} newbuildingId={layout.id} />;
};
